import { render, staticRenderFns } from "./RolePermissionList.vue?vue&type=template&id=c2a6cda8&"
import script from "./RolePermissionList.vue?vue&type=script&lang=ts&"
export * from "./RolePermissionList.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports